import { z } from "zod";
import { apiListSchema } from "./list";
import { personFromDto, PersonSchema, personToDto } from "./person";
//? DTO
export const CreateClientDtoSchema = z.object({
  Height: z.number().nullish(),
  Inseam: z.number().nullish(),
  EmergencyContact: z.string().nullish(),
  PassportExpiration: z.string().nullish(),
  PassportNumber: z.string().nullish(),
  Ensured: z.boolean().nullish(),
  DietaryRestrictions: z.string().nullish(),
  MedicalConditions: z.string().nullish(),
  Allergies: z.string().nullish(),
  Name: z.string().nullish(),
  Email: z.string(),
  Phone: z.string().nullish(),
  Birthdate: z.string().nullish(),
});
export type CreateClientDto = z.infer<typeof CreateClientDtoSchema>;
export const ClientDtoSchema = CreateClientDtoSchema.extend({
  Id: z.number(),
});
export type ClientDto = z.infer<typeof ClientDtoSchema>;
export const clientDtoListSchema = apiListSchema(ClientDtoSchema);
//? Model

export const CreateClientSchema = PersonSchema.extend({
  height: z.number().nullish(),
  inseam: z.number().nullish(),
  emergencyContact: z.string().nullish(),
  passportExpiration: z.string().nullish(),
  passportNumber: z.string().nullish(),
  ensured: z.boolean().nullish(),
  dietaryRestrictions: z.string().nullish(),
  medicalConditions: z.string().nullish(),
  allergies: z.string().nullish(),
});
export type CreateClient = z.infer<typeof CreateClientSchema>;

export const ClientSchema = CreateClientSchema.extend({
  id: z.string().min(1),
});
export type Client = z.infer<typeof ClientSchema>;
//? Mappers

export function createClientToDto(client: CreateClient): CreateClientDto {
  return {
    Height: client.height,
    Allergies: client.allergies,
    DietaryRestrictions: client.dietaryRestrictions,
    EmergencyContact: client.emergencyContact,
    Ensured: client.ensured,
    Inseam: client.inseam,
    MedicalConditions: client.medicalConditions,
    PassportExpiration: client.passportExpiration,
    PassportNumber: client.passportNumber,
    ...personToDto(client),
  };
}

export function clientFromDto(dto: ClientDto): Client {
  return {
    id: dto.Id.toString(),
    allergies: dto.Allergies,
    dietaryRestrictions: dto.DietaryRestrictions,
    emergencyContact: dto.EmergencyContact,
    ensured: dto.Ensured,
    height: dto.Height,
    inseam: dto.Inseam,
    medicalConditions: dto.MedicalConditions,
    passportExpiration: dto.PassportExpiration,
    passportNumber: dto.PassportNumber,
    ...personFromDto(dto),
  };
}

export function clientToDto(dto: Client): ClientDto {
  const createClientDto = createClientToDto(dto);
  return {
    Id: Number.parseInt(dto.id),
    ...createClientDto,
  };
}
